<template>
<div class="page-container" :style="backgroundStyle">
    <!-- 动态粒子背景 -->
    <div class="particles">
        <div v-for="n in 30" :key="n" class="particle" :style="getParticleStyle()"></div>
    </div>
    
    <!-- 渐变遮罩层 -->
    <div class="gradient-overlay"></div>
    
    <!-- 主内容区域 -->
    <div class="content-wrapper">
        <!-- 返回按钮 -->
        <router-link to="/" class="back-button">
            <LucideIcon name="arrow-left" :size="18" />
            <span>返回首页</span>
        </router-link>
        
        <div class="glass-card" :class="{ 'show': isLoaded }">
            <!-- 页面标题 -->
            <div class="page-header">
                <div class="icon-wrapper icon-pink">
                    <LucideIcon name="package" :size="28" color="#fff" />
                </div>
                <h1 class="title">客户端下载</h1>
                <p class="subtitle">选择您的平台，跳转至官方下载页面</p>
            </div>
            
            <!-- 分隔线 -->
            <div class="divider">
                <div class="divider-line"></div>
                <div class="divider-dot"></div>
                <div class="divider-line"></div>
            </div>
            
            <!-- 下载列表 -->
            <div class="download-container">
                <!-- Windows -->
                <div class="platform-section" :class="{ 'show': showSections }" style="--delay: 0.1s">
                    <div class="platform-header">
                        <LucideIcon name="monitor" :size="22" color="var(--color-primary)" />
                        <h2>Windows</h2>
                    </div>
                    <div class="download-items">
                        <a href="https://github.com/clash-verge-rev/clash-verge-rev/releases/latest" target="_blank" rel="noopener noreferrer" class="download-item external">
                            <div class="item-info">
                                <LucideIcon name="zap" :size="18" color="var(--color-accent)" />
                                <div class="item-details">
                                    <span class="item-name">Clash Verge Rev</span>
                                    <span class="item-desc">推荐 · 开源免费</span>
                                </div>
                            </div>
                            <span class="download-btn">
                                <LucideIcon name="external-link" :size="14" />
                                GitHub
                            </span>
                        </a>
                        <a href="https://github.com/chen08209/FlClash/releases/latest" target="_blank" rel="noopener noreferrer" class="download-item external">
                            <div class="item-info">
                                <LucideIcon name="zap" :size="18" color="var(--color-primary)" />
                                <div class="item-details">
                                    <span class="item-name">FlClash</span>
                                    <span class="item-desc">轻量 · 多平台 · 开源免费</span>
                                </div>
                            </div>
                            <span class="download-btn">
                                <LucideIcon name="external-link" :size="14" />
                                GitHub
                            </span>
                        </a>
                    </div>
                </div>
                
                <!-- macOS -->
                <div class="platform-section" :class="{ 'show': showSections }" style="--delay: 0.15s">
                    <div class="platform-header">
                        <LucideIcon name="apple" :size="22" color="var(--color-muted)" />
                        <h2>macOS</h2>
                    </div>
                    <div class="download-items">
                        <a href="https://github.com/clash-verge-rev/clash-verge-rev/releases/latest" target="_blank" rel="noopener noreferrer" class="download-item external">
                            <div class="item-info">
                                <LucideIcon name="zap" :size="18" color="var(--color-accent)" />
                                <div class="item-details">
                                    <span class="item-name">Clash Verge Rev</span>
                                    <span class="item-desc">推荐 · 支持 Intel / Apple Silicon</span>
                                </div>
                            </div>
                            <span class="download-btn">
                                <LucideIcon name="external-link" :size="14" />
                                GitHub
                            </span>
                        </a>
                        <a href="https://github.com/chen08209/FlClash/releases/latest" target="_blank" rel="noopener noreferrer" class="download-item external">
                            <div class="item-info">
                                <LucideIcon name="zap" :size="18" color="var(--color-primary)" />
                                <div class="item-details">
                                    <span class="item-name">FlClash</span>
                                    <span class="item-desc">轻量 · Intel / Apple Silicon</span>
                                </div>
                            </div>
                            <span class="download-btn">
                                <LucideIcon name="external-link" :size="14" />
                                GitHub
                            </span>
                        </a>
                        <a href="https://apps.apple.com/app/stash-rule-based-proxy/id1596063349" target="_blank" rel="noopener noreferrer" class="download-item external">
                            <div class="item-info">
                                <LucideIcon name="target" :size="18" color="#64b5f6" />
                                <div class="item-details">
                                    <span class="item-name">Stash</span>
                                    <span class="item-desc">付费 · 兼容 Clash 配置</span>
                                </div>
                            </div>
                            <span class="download-btn appstore-btn">
                                <LucideIcon name="external-link" :size="14" />
                                App Store
                            </span>
                        </a>
                    </div>
                </div>
                
                <!-- iOS -->
                <div class="platform-section" :class="{ 'show': showSections }" style="--delay: 0.2s">
                    <div class="platform-header">
                        <LucideIcon name="smartphone" :size="22" color="var(--color-primary)" />
                        <h2>iOS</h2>
                        <span class="platform-badge">需美区账号</span>
                    </div>
                    <div class="download-items">
                        <a href="https://apps.apple.com/us/app/shadowrocket/id932747118" target="_blank" rel="noopener noreferrer" class="download-item external">
                            <div class="item-info">
                                <LucideIcon name="rocket" :size="18" color="var(--color-primary)" />
                                <div class="item-details">
                                    <span class="item-name">Shadowrocket</span>
                                    <span class="item-desc">$2.99 · 推荐 · 简单易用</span>
                                </div>
                            </div>
                            <span class="download-btn appstore-btn">
                                <LucideIcon name="external-link" :size="14" />
                                App Store
                            </span>
                        </a>
                        <a href="https://apps.apple.com/us/app/stash-rule-based-proxy/id1596063349" target="_blank" rel="noopener noreferrer" class="download-item external">
                            <div class="item-info">
                                <LucideIcon name="target" :size="18" color="#64b5f6" />
                                <div class="item-details">
                                    <span class="item-name">Stash</span>
                                    <span class="item-desc">$3.99 · 兼容 Clash 配置</span>
                                </div>
                            </div>
                            <span class="download-btn appstore-btn">
                                <LucideIcon name="external-link" :size="14" />
                                App Store
                            </span>
                        </a>
                        <a href="https://apps.apple.com/us/app/quantumult-x/id1443988620" target="_blank" rel="noopener noreferrer" class="download-item external">
                            <div class="item-info">
                                <LucideIcon name="target" :size="18" color="var(--color-accent)" />
                                <div class="item-details">
                                    <span class="item-name">Quantumult X</span>
                                    <span class="item-desc">$7.99 · 进阶用户</span>
                                </div>
                            </div>
                            <span class="download-btn appstore-btn">
                                <LucideIcon name="external-link" :size="14" />
                                App Store
                            </span>
                        </a>
                        <a href="https://apps.apple.com/us/app/surge-5/id1442620678" target="_blank" rel="noopener noreferrer" class="download-item external">
                            <div class="item-info">
                                <LucideIcon name="waves" :size="18" color="#64b5f6" />
                                <div class="item-details">
                                    <span class="item-name">Surge 5</span>
                                    <span class="item-desc">$49.99 · 专业级</span>
                                </div>
                            </div>
                            <span class="download-btn appstore-btn">
                                <LucideIcon name="external-link" :size="14" />
                                App Store
                            </span>
                        </a>
                    </div>
                </div>
                
                <!-- Android -->
                <div class="platform-section" :class="{ 'show': showSections }" style="--delay: 0.25s">
                    <div class="platform-header">
                        <LucideIcon name="bot" :size="22" color="var(--color-success-light)" />
                        <h2>Android</h2>
                    </div>
                    <div class="download-items">
                        <a href="https://github.com/chen08209/FlClash/releases/latest" target="_blank" rel="noopener noreferrer" class="download-item external">
                            <div class="item-info">
                                <LucideIcon name="zap" :size="18" color="var(--color-accent)" />
                                <div class="item-details">
                                    <span class="item-name">FlClash</span>
                                    <span class="item-desc">推荐 · Material Design · 开源免费</span>
                                </div>
                            </div>
                            <span class="download-btn">
                                <LucideIcon name="external-link" :size="14" />
                                GitHub
                            </span>
                        </a>
                        <a href="https://github.com/clash-verge-rev/clash-verge-rev/releases/latest" target="_blank" rel="noopener noreferrer" class="download-item external">
                            <div class="item-info">
                                <LucideIcon name="zap" :size="18" color="var(--color-primary)" />
                                <div class="item-details">
                                    <span class="item-name">Clash Verge Rev</span>
                                    <span class="item-desc">功能丰富 · 开源免费</span>
                                </div>
                            </div>
                            <span class="download-btn">
                                <LucideIcon name="external-link" :size="14" />
                                GitHub
                            </span>
                        </a>
                    </div>
                </div>
            </div>

            <!-- 底部提示 -->
            <div class="footer-tip">
                <LucideIcon name="lightbulb" :size="16" color="rgba(255, 193, 7, 0.9)" />
                <span>所有链接均跳转至官方发布页面，请根据您的设备架构选择对应安装包</span>
            </div>
            
            <!-- 底部波浪装饰 -->
            <div class="footer-decoration">
                <div class="wave-line"></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import backgroundMixin from '@/mixins/background'

export default {
    name: 'SoftwareDownload',
    mixins: [backgroundMixin],
    data() {
        return {
            showSections: false
        };
    },
    mounted() {
        // Mixin 已处理 fetchBackground() 和 triggerLoadAnimation()
        setTimeout(() => {
            this.showSections = true;
        }, 400);
    }
}
</script>

<style scoped>
/* ===== 基础容器 ===== */
.page-container {
    position: relative;
    min-height: 100vh;
    width: 100vw;
    overflow-x: hidden;
    font-family: var(--font-body);
    color: var(--color-ink);
}

/* ===== 粒子动画 ===== */
.particles {
    position: fixed;
    top: 0; left: 0;
    width: 100%; height: 100%;
    overflow: hidden;
    z-index: 1;
    pointer-events: none;
}

.particle {
    position: absolute;
    bottom: -20px;
    background: radial-gradient(circle, rgba(255,255,255,0.8) 0%, rgba(255,255,255,0) 70%);
    border-radius: 50%;
    animation: float-up linear infinite;
}

@keyframes float-up {
    0% { transform: translateY(0); opacity: 0; }
    10% { opacity: 1; }
    90% { opacity: 1; }
    100% { transform: translateY(-100vh); opacity: 0; }
}

/* ===== 渐变遮罩 ===== */
.gradient-overlay {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: linear-gradient(135deg, rgba(26, 26, 46, 0.7) 0%, rgba(22, 33, 62, 0.6) 100%);
    z-index: 2;
    pointer-events: none;
}

/* ===== 内容包装器 ===== */
.content-wrapper {
    position: relative;
    z-index: 10;
    padding: var(--space-xl);
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* ===== 返回按钮 ===== */
.back-button {
    align-self: flex-start;
    display: flex;
    align-items: center;
    gap: var(--space-sm);
    padding: 10px var(--space-xl);
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: var(--radius-md);
    color: rgba(255, 255, 255, 0.8);
    text-decoration: none;
    font-size: 0.95rem;
    margin-bottom: var(--space-xl);
    transition: all var(--duration-normal) ease;
    cursor: pointer;
}

.back-button:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: translateX(-5px);
    color: #fff;
}

/* ===== 玻璃态卡片 ===== */
.glass-card {
    width: 100%;
    max-width: 600px;
    background: var(--color-surface-glass);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: var(--radius-2xl);
    border: 1px solid var(--color-border);
    padding: var(--space-4xl) var(--space-3xl);
    box-shadow: var(--shadow-card);
    transform: translateY(30px) scale(0.95);
    opacity: 0;
    transition: all var(--duration-slow) var(--ease-out);
    margin-bottom: var(--space-4xl);
}

.glass-card.show {
    transform: translateY(0) scale(1);
    opacity: 1;
}

/* ===== 页面头部 ===== */
.page-header {
    text-align: center;
    margin-bottom: var(--space-2xl);
}

.icon-wrapper {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: var(--radius-xl);
    margin-bottom: var(--space-lg);
}

.icon-pink {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    box-shadow: 0 4px 20px rgba(240, 147, 251, 0.4);
}

.title {
    font-size: 2rem;
    font-weight: 700;
    font-family: var(--font-display);
    background: linear-gradient(90deg, #f093fb, #f5576c, #4facfe, #f093fb);
    background-size: 300% 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: gradient-flow 4s ease infinite;
    margin-bottom: var(--space-sm);
}

@keyframes gradient-flow {
    0%, 100% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
}

.subtitle {
    color: var(--color-subtle);
    font-size: 0.95rem;
}

/* ===== 分隔线 ===== */
.divider {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-md);
    margin: var(--space-2xl) 0;
}

.divider-line {
    height: 1px;
    width: 60px;
    background: linear-gradient(90deg, transparent, rgba(240, 147, 251, 0.5), transparent);
}

.divider-dot {
    width: 6px;
    height: 6px;
    background: linear-gradient(135deg, #f093fb, #f5576c);
    border-radius: 50%;
}

/* ===== 下载区块 ===== */
.download-container {
    display: flex;
    flex-direction: column;
    gap: var(--space-2xl);
}

.platform-section {
    opacity: 0;
    transform: translateY(20px);
    transition: all 0.5s ease;
    transition-delay: var(--delay);
}

.platform-section.show {
    opacity: 1;
    transform: translateY(0);
}

.platform-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: var(--space-md);
}

.platform-header h2 {
    font-size: 1.1rem;
    font-weight: 600;
    color: #fff;
    margin: 0;
}

.platform-badge {
    font-size: 0.7rem;
    padding: 3px 8px;
    background: rgba(255, 193, 7, 0.2);
    border: 1px solid rgba(255, 193, 7, 0.3);
    border-radius: var(--radius-pill);
    color: var(--color-warning);
}

/* ===== 下载项 ===== */
.download-items {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.download-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 18px;
    background: var(--color-surface-elevated);
    border: 1px solid var(--color-border-subtle);
    border-radius: 14px;
    color: #fff;
    text-decoration: none;
    transition: all var(--duration-normal) ease;
    cursor: pointer;
}

.download-item:hover {
    background: rgba(79, 172, 254, 0.1);
    border-color: rgba(79, 172, 254, 0.3);
    transform: translateY(-2px);
    box-shadow: 0 6px 24px rgba(79, 172, 254, 0.2);
}

.item-info {
    display: flex;
    align-items: center;
    gap: var(--space-md);
}

.item-details {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.item-name {
    font-size: 1rem;
    font-weight: 500;
}

.item-desc {
    font-size: 0.8rem;
    color: var(--color-subtle);
}

.download-btn {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: var(--space-sm) 14px;
    background: linear-gradient(135deg, rgba(79, 172, 254, 0.3), rgba(0, 242, 254, 0.3));
    border-radius: 10px;
    font-size: 0.85rem;
    font-weight: 500;
    white-space: nowrap;
    transition: all var(--duration-normal) ease;
}

.download-item:hover .download-btn {
    background: linear-gradient(135deg, #4facfe, #00f2fe);
    box-shadow: 0 4px 15px rgba(79, 172, 254, 0.4);
}

.appstore-btn {
    background: linear-gradient(135deg, rgba(100, 181, 246, 0.3), rgba(130, 177, 255, 0.3));
}

.download-item:hover .appstore-btn {
    background: linear-gradient(135deg, #64b5f6, #82b1ff);
    box-shadow: 0 4px 15px rgba(100, 181, 246, 0.4);
}

/* ===== 底部提示 ===== */
.footer-tip {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--space-sm);
    margin-top: 28px;
    padding: var(--space-md);
    background: rgba(255, 193, 7, 0.1);
    border: 1px solid rgba(255, 193, 7, 0.2);
    border-radius: var(--radius-md);
    color: rgba(255, 193, 7, 0.9);
    font-size: 0.88rem;
    text-align: left;
    line-height: 1.5;
}

/* ===== 底部装饰 ===== */
.footer-decoration {
    display: flex;
    justify-content: center;
    margin-top: var(--space-3xl);
}

.wave-line {
    width: 60px;
    height: 4px;
    background: linear-gradient(90deg, #f093fb, #f5576c, #4facfe);
    border-radius: 2px;
    animation: wave 2s ease-in-out infinite;
}

@keyframes wave {
    0%, 100% { transform: scaleX(1); }
    50% { transform: scaleX(1.5); }
}

/* ===== 响应式 ===== */
@media (max-width: 480px) {
    .glass-card {
        padding: 28px var(--space-xl);
        border-radius: var(--radius-xl);
    }
    
    .title {
        font-size: 1.6rem;
    }
    
    .download-item {
        flex-direction: column;
        align-items: flex-start;
        gap: var(--space-md);
    }
    
    .download-btn {
        width: 100%;
        justify-content: center;
    }
}

@media (min-width: 481px) and (max-width: 768px) {
    .glass-card {
        max-width: 520px;
    }
}

@media (min-width: 1024px) {
    .glass-card {
        max-width: 640px;
        padding: 48px 40px;
    }
}
</style>
